/**
 * Stap 3: de meerkeuzevragen (toets, deel 1). Links de tekst, rechts de
 * vragen. Versturen kan pas als elke vraag een antwoord heeft.
 */
import React from 'react';
import { Send } from 'lucide-react';
import { MeerkeuzeVraag } from '../onderdelen/MeerkeuzeVraag';
import { TekstPaneel } from '../onderdelen/TekstPaneel';
import { stijlen } from '../stijlen';

export function Meerkeuze({ titel, alineas, vragen, antwoorden, onKies, onVerstuur, bezig = false }) {
  // Zonder vragen valt er niets te versturen (anders telt een lege toets als gemaakt).
  const compleet = vragen.length > 0 && vragen.every(v => antwoorden[v.id]);
  return (
    <div style={stijlen.toetsRaster}>
      <TekstPaneel titel={titel} alineas={alineas} />
      <div style={stijlen.toetsPaneel}>
        <h3 style={{ ...stijlen.paneelLabel, marginBottom: 8 }}>Toets - Deel 1</h3>
        <h2 style={stijlen.paneelTitel}>Vragen over de tekst</h2>
        {vragen.length === 0 && (
          <div className="alert alert-error">
            Er staan geen vragen klaar. Vraag je leerkracht om de toets opnieuw te maken.
          </div>
        )}
        {vragen.map((v, i) => (
          <MeerkeuzeVraag key={v.id} nummer={i + 1} vraag={v} gekozen={antwoorden[v.id]} onKies={letter => onKies(v.id, letter)} />
        ))}
        {/* Zolang het versturen loopt, kan het niet nog een keer. */}
        <button style={{ ...stijlen.groteKnop, opacity: compleet && !bezig ? 1 : 0.5 }} onClick={onVerstuur}
          disabled={!compleet || bezig}>
          <Send size={18} /> {bezig ? 'Versturen...' : 'Verstuur antwoorden'}
        </button>
      </div>
    </div>
  );
}
